var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2363_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6274 4.44406C11.1904 4.0767 10.5219 4.12045 10.1425 4.5728L9.91455 4.84252L11.5304 6.19835L11.7481 5.92962C12.1226 5.48431 12.0752 4.81924 11.6274 4.44406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06365 8.21564L6.9434 8.35795C6.83903 8.48292 6.76384 8.63227 6.72608 8.79054L6.39925 10.1583C6.36836 10.2878 6.41333 10.4237 6.51529 10.5092C6.61452 10.5926 6.75449 10.6168 6.88094 10.5628L8.17147 10.0031C8.32082 9.93825 8.45472 9.83836 8.55908 9.71442L8.67976 9.57164L7.06365 8.21564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4606 5.3793L7.51709 7.67885L9.13311 9.03485L11.0765 6.73514L9.4606 5.3793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81303 1.55869L7.47752 0.289757C7.35126 0.170061 7.19594 0.0995612 7.03223 0.0537643V2.10937H9.11938C9.07577 1.90055 8.96936 1.70709 8.81303 1.55869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04209 8.62713C6.10492 8.36414 6.23022 8.11523 6.40394 7.90718L9.1416 4.66779V2.8125H6.68066C6.48634 2.8125 6.3291 2.65526 6.3291 2.46094V0H1.05566C0.474086 0 0.000976562 0.473109 0.000976562 1.05469V10.9453C0.000976562 11.5269 0.474086 12 1.05566 12H8.08691C8.66849 12 9.1416 11.5269 9.1416 10.9453V10.1142L9.09595 10.1683C8.92326 10.3739 8.70044 10.5398 8.45221 10.6479L7.16064 11.2079C6.79661 11.3651 6.37523 11.3094 6.06339 11.0482C5.75542 10.7897 5.62188 10.3863 5.71525 9.99492L6.04209 8.62713ZM1.75879 2.10938H5.27441C5.46873 2.10938 5.62598 2.26662 5.62598 2.46094C5.62598 2.65526 5.46873 2.8125 5.27441 2.8125H1.75879C1.56447 2.8125 1.40723 2.65526 1.40723 2.46094C1.40723 2.26662 1.56447 2.10938 1.75879 2.10938ZM1.75879 4.24219H7.38379C7.57811 4.24219 7.73535 4.39943 7.73535 4.59375C7.73535 4.78807 7.57811 4.94531 7.38379 4.94531H1.75879C1.56447 4.94531 1.40723 4.78807 1.40723 4.59375C1.40723 4.39943 1.56447 4.24219 1.75879 4.24219ZM4.57129 9.16406H1.75879C1.56447 9.16406 1.40723 9.00682 1.40723 8.8125C1.40723 8.61818 1.56447 8.46094 1.75879 8.46094H4.57129C4.76561 8.46094 4.92285 8.61818 4.92285 8.8125C4.92285 9.00682 4.76561 9.16406 4.57129 9.16406ZM1.75879 7.05469C1.56447 7.05469 1.40723 6.89745 1.40723 6.70312C1.40723 6.5088 1.56447 6.35156 1.75879 6.35156H5.97754C6.17186 6.35156 6.3291 6.5088 6.3291 6.70312C6.3291 6.89745 6.17186 7.05469 5.97754 7.05469H1.75879Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2363_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.e98794c910aeadd8841f91dff5082e95.svg";
export { ForwardRef as ReactComponent };